import type { NotifyPort } from '@/features/messages/domain/notify'
import type { ChatPort, Message } from '../domain/chat'

// Publishes a plain-text message. The text is wrapped in the content map the
// backend expects ({ txt }); richer payloads can extend the map later.
// When replyTo is provided, reply metadata is written into head so the thread
// can render a preview of the referenced message.
const publishMessage = async (
	port: ChatPort,
	topicId: string,
	text: string,
	notify: NotifyPort,
	replyTo?: Message,
): Promise<Message | null> => {
	const trimmed = text.trim()
	if (!trimmed) return null
	try {
		const head = replyTo
			? {
					replyTo: replyTo.id,
					replyToName: replyTo.fromName,
					replyToTxt: typeof replyTo.content.txt === 'string' ? replyTo.content.txt : '',
				}
			: undefined
		return await port.publish({ topicId, content: { txt: trimmed }, head })
	} catch {
		notify.error('chat.sendFailed')
		return null
	}
}

export { publishMessage }
